import { useFeatureFlag } from "@/contexts/FeatureFlagContext"

/**
 * STEP C3/C4: does the declaration review load in pages (one regulation, one page
 * of articles at a time)? `MC_REVIEW_PAGED` is the per-org switch for the visible
 * change; it counts only where `MC_DECLARATION_TABLES` is on too, so the paged
 * screen never runs on the slow JSON path (decided 2026-10-29). Off = today's
 * screen, unchanged.
 */
export function useReviewPaged(): boolean {
  const paged = useFeatureFlag("MC_REVIEW_PAGED")
  const tables = useFeatureFlag("MC_DECLARATION_TABLES")
  return paged && tables
}
